import { render, staticRenderFns } from "./DestacadosComponent.vue?vue&type=template&id=71b45d0a&"
import script from "./DestacadosComponent.vue?vue&type=script&lang=ts&"
export * from "./DestacadosComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports